export const environment = {
  hemnetServiceUrl: 'https://hemnet-www-test.nytthem.sparbankensyd.se/api',
  utmTags: '?utm_source=hemnet_test&utm_medium=kalkyl&utm_campaign=bolan',
  rtUrl: 'https://hemnet-www-test.nytthem.sparbankensyd.se/interests',
  calculatorUrl: 'https://sparbankensyd.beregner.net/',
  loanPromiseUrl: 'https://www-test.nytthem.sparbankensyd.se/#/lanelofte',
  production: false
}
